import { ref, computed, watch } from "vue";
import { format } from "date-fns";

export function useNoteFormGlobal(props, emit, activeTabPrefix = "activeTab_") {
  const localNoteForm = ref({});

  // Sincronizar formulario local con el que viene del padre
  const syncFromProps = () => {
    localNoteForm.value = { ...(props.noteForm || {}) };
  };

  syncFromProps();

  watch(
    () => props.noteForm,
    () => {
      syncFromProps();
    },
    { deep: true }
  );

  // Si cambia el ID seleccionado, refrescar el formulario local
  watch(
    () => props.currentId,
    () => {
      syncFromProps();
    }
  );

  // Lista ya filtrada que recibe el componente padre
  const filteredNotes = computed(() =>
    Array.isArray(props.notes) ? props.notes : []
  );

  const isEditing = computed(() => !!props.currentId && props.currentId > 0);

  const formatDate = (date) => {
    try {
      return date ? format(new Date(date), "dd/MM/yyyy") : "";
    } catch (e) {
      return "";
    }
  };

  const selectNoteForm = (note) => {
    if (typeof props.selectNote === "function") {
      props.selectNote(note);
    }
  };

  const handleDuplicateNote = () => {
    // Duplicar limpiando el id y cambiando a modo crear
    localNoteForm.value = { ...localNoteForm.value, id: null };
    emit("clear-all-errors");
    emit("update:activeTab", "create");
    // Persistir preferencia del tab si aplica
    try {
      const recordId = props.patientRecord?.id;
      if (recordId) {
        localStorage.setItem(`${activeTabPrefix}${recordId}`, "create");
      }
    } catch (_) {
      // Ignorar errores de localStorage
    }
  };

  const handleSubmit = async () => {
    emit("save-note", { ...localNoteForm.value });
  };

  const deleteNote = (fieldName) => {
    emit("delete-note", { ...localNoteForm.value }, fieldName);
  };

  return {
    localNoteForm,
    filteredNotes,
    handleSubmit,
    selectNoteForm,
    deleteNote,
    handleDuplicateNote,
    formatDate,
    isEditing,
  };
}
